import { module } from 'stereomodularjs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.firstLoadTl = gsap.timeline();

        this.firstLoadTl.to('.c-transition__logo__icon', {
            delay: 0.3,
            duration: 0.7,
            autoAlpha: 1,
            transform: 'translate(-50%, -50%) scale(1)',
            ease: 'power2.out',
        });
        this.firstLoadTl.to('.c-transition__logo__icon', {
            duration: 0.7,
            left: 0,
            transform: 'translate(0, -50%) scale(1)',
            ease: 'power2.out',
        });
        this.firstLoadTl.to('.c-transition__logo__full', {
            duration: 0.7,
            autoAlpha: 1,
            transform: 'translate(-50%, -50%)',
            ease: 'power2.out',
        }, '-=0.3');
        this.firstLoadTl.to('.c-transition__logo', {
            duration: 0.7,
            autoAlpha: 0,
            transform: 'translate(-50%, -50%) scale(0.8)',
            ease: 'power2.out',
        }, '+=0.3');
    }

    destroy() {
        this.firstLoadTl.kill();
        this.firstLoadTl = null;
        super.destroy();
        this.el = null;
    }
}
